import React, { useState, useEffect } from "react";

type ProductImage = {
    imageUrl: string;
    id: number;
}

export function ProductImageGallery({ productImages }: { productImages: ProductImage[] }) {
  // Setting the default active image
  const [activeImage, setActiveImage] = useState<string>(
    productImages.length > 0 ? productImages[0].imageUrl : ''
  );

  return (
    <div className="grid gap-4">
      {/* Displaying the active image */}
      <div>
        <img
          className="h-auto w-full max-w-full rounded-lg object-cover object-center md:h-[480px]"
          src={activeImage}
          alt="Active product"
        />
      </div>

      {/* Displaying the thumbnails */}
      <div className="grid grid-cols-5 gap-4">
        {productImages.map(({ imageUrl }, index) => (
          <div key={index}>
            <img
              onClick={() => setActiveImage(imageUrl)}
              src={imageUrl}
              className="h-20 max-w-full cursor-pointer rounded-lg object-cover object-center"
              alt={`Gallery image ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}